import * as React from 'react';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Select from "react-select";
import {Accordion, Card, Col, Row} from "react-bootstrap";
import {listUsers, logout} from "../actions/userActions";
import {listPlayerActivities, listPlayerLogDates, listPlayerLogForDate, listPlayers} from "../actions/playerActions";
import Message from "../components/Message";

const AdminScreen = ({history, language, t}) => {

    const userLogin = useSelector((state) => state.userLogin);
    const {userInfo} = userLogin;
    const dispatch = useDispatch();

    const [userOptions, setUserOptions] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const userList = useSelector((state) => state.userList);
    const {loading, users, error} = userList;

    const [activityDate, setActivityDate] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const activityList = useSelector((state) => state.playerActivities);
    const {loading: activitiesLoading, activities, error: activitiesError} = activityList;

    useEffect(() => {
        if (!userInfo || !userInfo.isAdmin) {
            history.push('/login');
        }
    }, [userInfo, history]);

    useEffect(() => {
        dispatch(listUsers());
    },[dispatch]);

    useEffect(()=>{
        if(users?.length > 0){
            const moddedUsers = users.map(user => {
                user.label = user.name + ' - ' + user.email + `\n(${user.folder})`;
                user.value = user.email;
                return user;
            });
            setUserOptions(moddedUsers);
        }
    }, [users])

    useEffect(()=>{
        if(error && error.includes('Not authorized')){
            dispatch(logout());
            history.push('/login');
        }
    },[error]);

    useEffect(()=>{
        if(activities !== {}){
            // TODO
            console.log(activities);
        }
        else {
            // TODO
        }
    }, [activities]);

    const onUserChanged = (userFromSelect) => {
        setSelectedUser(userFromSelect);
        dispatch(listPlayerActivities(userFromSelect._id, activityDate));
    }

    return (
        <>
            <h1>
                {t('activity')}
            </h1>
            <Row className='mb-3'>
                <Col className='mt-auto mb-auto'><input
                    type='date'
                    onChange={(e) => {
                        let date = e.target.value;
                        if(date.includes('-')){
                            date = date.split('-')[0] + '-' + date.split('-')[1];
                        }
                        else if(date.includes('.')){
                            date = date.split('.')[0] + '-' + date.split('.')[1];
                        }
                        console.log(date);
                        setActivityDate(date);
                        if(selectedUser !== null){
                            dispatch(listPlayerActivities(selectedUser._id, date));
                        }
                        setSelectedDate(e.target.value);
                    }}
                    value={selectedDate}
                /></Col>
                <Col><Select options={userOptions} onChange={onUserChanged} placeholder={'Felhasználó'}/></Col>
            </Row>

            {error ? <Message variant='danger'>{error}</Message> : null}
            {activitiesError ? <Message variant='danger'>{activitiesError}</Message> : null}

            {selectedUser !== null? <div>
                <Accordion className='mt-3'>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                                Felhasználó zene aktivitás {activityDate !== '' ? `: ${activityDate}` : ''}
                            <br/>
                            Aktív zene lejátszók: {activities.activityNumber ? activities.activityNumber : '-'}

                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>{activities?.activities?.map((activity) => <>
                                <div className='mb-3' key={activity._id}>Név: {activity.name} <br/>Pin: {activity.pin}</div>
                            </>)}</Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                <Accordion className='mt-3'>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            Felhasználó videó aktivitás {activityDate !== '' ? `: ${activityDate}` : ''}
                            <br/>
                            Aktív videó lejátszók: {activities.videoActivityNumber ? activities.videoActivityNumber : '-'}

                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>{activities?.videoActivities?.map((activity) => <>
                                <div className='mb-3' key={activity._id}>Név: {activity.name} <br/>Pin: {activity.pin}</div>
                            </>)}</Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div> : null}
        </>
    );
};

export default AdminScreen;
